const chatSteps = {
  STEP_BOOTING: 'STEP_BOOTING',
  STEP_CATEGORY: 'STEP_CATEGORY',
  STEP_CHAT: 'STEP_CHAT',
  STEP_CONNECTING_TO_EXPERT: 'STEP_CONNECTING_TO_EXPERT',
  STEP_AUTOMATION: 'STEP_AUTOMATION',
  STEP_EMAIL: 'STEP_EMAIL',
  STEP_FINISHED: 'STEP_FINISHED',
  STEP_NAME: 'STEP_NAME',
  STEP_QUESTION: 'STEP_QUESTION',
  STEP_RATE: 'STEP_RATE',
  STEP_RATE_BAD: 'STEP_RATE_BAD',
} as const;

type ChatStep = keyof typeof chatSteps | null;
export { chatSteps, type ChatStep };
